module.exports = __webpack_public_path__ + "img/American-Express.961c21e4.svg";